import type { ApplicationConfig } from '@angular/core';
import {
  ErrorHandler,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { credentialsInterceptor } from './core/http/interceptors/credentials.interceptor';
import { csrfInterceptor } from './core/http/interceptors/csrf.interceptor';
import { apiErrorInterceptor } from './core/http/interceptors/api-error.interceptor';
import { sessionExpiredInterceptor } from './core/http/interceptors/session-expired.interceptor';
import { GlobalErrorHandler } from './core/error-handling/global-error-handler';
import { AuthService } from './core/auth/auth.service';
import { provideTranslations, LocaleSyncService } from './core/i18n';
import { ThemeService } from './core/theme';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        credentialsInterceptor,
        csrfInterceptor,
        apiErrorInterceptor,
        sessionExpiredInterceptor,
      ])
    ),
    provideTranslations(),
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      // Démarre les services qui s'auto-wirent via effect au constructeur.
      inject(ThemeService);
      inject(LocaleSyncService);

      return auth.retrySession();
    }),
  ],
};
